/**
 * events.js — Shared custom event utilities.
 *
 * Usage:
 *   TRYEvents.emit('cart:open');
 *   TRYEvents.on('cart:open', () => cartDrawer.open());
 */
const TRYEvents = {
  /**
   * Dispatch a bubbling CustomEvent on the target.
   * @param {string} name
   * @param {object} [detail]
   * @param {EventTarget} [target]
   */
  emit(name, detail = {}, target = document) {
    target.dispatchEvent(
      new CustomEvent(name, { bubbles: true, cancelable: true, detail })
    );
  },

  /**
   * Listen for a CustomEvent. Returns an unsubscribe function.
   * @param {string} name
   * @param {EventListener} handler
   * @param {EventTarget} [target]
   * @returns {() => void}
   */
  on(name, handler, target = document) {
    target.addEventListener(name, handler);
    return () => target.removeEventListener(name, handler);
  },
};

window.TRYEvents = TRYEvents;
